// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBAn10aXWdfYtxhFZbzyh_TnZM2sk_u26U",
  authDomain: "un-locked-game.firebaseapp.com",
  projectId: "un-locked-game",
  storageBucket: "un-locked-game.firebasestorage.app",
  messagingSenderId: "1019262016383",
  appId: "1:1019262016383:web:e6408fab425fe1d4fa184a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);